export default {
  title: 'Désactiver l\'accès à une plateforme',
  subtitle: 'Vous pouvez désactiver l\'accès d\'un utilisateur à une plateforme',
  searchLabel: 'Rechercher',
  disableAccess: 'Désactiver l\'accès à',
  qDialog: {
    title: 'Confirmation nécessaire',
    subtitle: 'Désactivation de l\'accès à cette plateforme',
    content: 'Êtes-vous sûr de vouloir désactiver l\'accès à {platformDisable} pour '
  },
  noUser: 'Aucun utilisateur n\'a été trouvé',
  listOfUsersTable: {
    name: 'Prénom, Nom',
    email: 'Adresse mail',
    type: 'Type',
    access: 'Accès'
  }
}
